export default __webpack_public_path__ + "static/media/before@3x.ad1ee178.png";